<template>
  <div @click="link" :data-href="'/companies/'+company.company_id" class="chart__link">
    <LikeDelete v-if="options.like_delete" :company="company" @unlike="unlike"></LikeDelete>
    <HistoryDelete v-if="options.history_delete" :company="company" @deleteCompany="deleteCompany"></HistoryDelete>
    <div :class="(searchStore.target == NaviRequest.TARGET_AVERAGE_ANNUAL_SALARY)? 'chart__wrap-s is-avg':'chart__wrap-s'">
      <div class="chart__wrap-top">
        <div class="chart__wrap-cate">
          <p class="chart-item__cate is-blue">{{ company.industry_name }}</p>
          <p class="chart-item__cate is-green">{{ company.prefecture_name }}</p>
          <p v-if="company.employee_category" class="chart-item__cate">{{ company.employee_category }}</p>
        </div>
        <div class="chart__wrap-ttl">
          <h3 class="chart-item__ttl">{{ company.company_name }}</h3>
          <p class="chart-item__txt-s">本社所在地／{{ company.location }}</p>
        </div>
      </div>
      <div :class="(searchStore.target == NaviRequest.TARGET_AVERAGE_ANNUAL_SALARY)? 'chart__wrap-salary is-avg':'chart__wrap-salary'">
        <div v-if="searchStore.target == NaviRequest.TARGET_AVERAGE_ANNUAL_SALARY" class="chart__wrap-salary-avg">
          <p class="chart-item__txt-m">平均年収(平均{{ (company.average_age)? company.average_age : '---' }}歳)</p>
          <p class="chart-item__salary">
            <strong>{{ formatAvg.toLocaleString() }}</strong>万円
          </p>  
        </div>
        <div class="chart__wrap-salary-default">
        <p class="chart-item__txt-m">初任給額（月給）</p>
        <p class="chart-item__salary" v-if="!company.min_salary && !company.max_salary">
          <strong>---</strong>円
        </p>
        <p class="chart-item__salary" v-if="company.min_salary || company.max_salary">
          <strong>{{ (company.min_salary)? company.min_salary.toLocaleString():'---' }}</strong>円<strong>～</strong><strong>
          {{ (company.max_salary)? company.max_salary.toLocaleString():'---' }}</strong>円
        </p>
        </div>
      </div>
    </div>
    <div class="chart__wrap-s is-bottom">
      <div class="chart__wrap-txt">
        <p class="chart-item__txt-l"><small>売上高</small>{{ formatSales }}<small v-if="company.sales!=null">億円</small></p>
        <p class="chart-item__txt-l"><small>従業員数</small>{{ (company.employees)? company.employees.toLocaleString()+'人':'---' }}<small></small></p>
      </div>
      <div class="chart__wrap-sns">
        <div class="sns">
          <Like v-if="options.like" :company="company" @like="like" @unlike="unlike"></Like>
          <Share v-if="options.share" :company="company"></Share>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import Share from "./Share.vue";
import Like from "./Like.vue";
import LikeDelete from "./LikeDelete.vue";
import HistoryDelete from "./HistoryDelete.vue";
import {computed} from "vue";
import {useSearchStore} from "../../stores/search";
import {NaviRequest} from "../../api/NaviRequest";


const searchStore = useSearchStore();
const emit = defineEmits(['deleteCompany', 'like', 'unlike']);

const props = defineProps({
  company: {
    type: Object,
    required: true
  },
  options: {
    type: Object,
    required: false
  }
});

const formatSales = computed(() => {
  if(company.value.sales==null){
    return '---';
  }
  const formated = navi.formatSalesPrice(company.value.sales);
  if (formated.length == 1) {
    return formated[0].value;
  } else {
    return formated[0].value + formated[0].label + formated[1].value;
  }
})

const formatAvg = computed(()=>{
  if(company.value.average_annual_salary==null){
    return '---';
  }
  const man = Math.round(company.value.average_annual_salary / 10000);
  return man;
})

const company = computed(() => props.company);

const link = e => {
  location.href = e.currentTarget.dataset.href
}

const deleteCompany = (company) => {
  emit('deleteCompany', company);
}
const like = (company) => {
  emit('like', company);
}
const unlike = (company) => {
  emit('unlike', company);
}

</script>